'use client';
import { useTranslations } from 'next-intl';
import { useRef, useState } from 'react';

import { PATH } from '@/consts/path';
import useOutside from '@/hooks/click/useOutside';
import useEscape from '@/hooks/key/useEscape';
import IntLink from '@/server/link/IntLink';
import Logo60 from '@/ui/assets/img/Logo60';
import CrossIcon from '@/ui/assets/svg/CrossIcon1';
import HamburgerIcon from '@/ui/assets/svg/HamburgerIcon1';
import LocaleSwitcherNav from '@/ui/client/btn/lang/LocaleSwitcherNav';
import ThemeSwitcher from '@/ui/client/btn/lang/ThemeSwitcherNav';

import AsideNavMenu from './aside';
import styles from './styles.module.css';

const Navbar = () => {
  const t = useTranslations('nav');
  const [showAside, setShowAside] = useState(false);
  const asideRef = useRef();

  useEscape(() => setShowAside(false));
  useOutside(asideRef, () => setShowAside(false));

  const toggleAside = () => setShowAside((prevState) => !prevState);

  const iconStyle = showAside ? 'rotateIn' : 'grow';

  return (
    <>
      <nav className={styles.navbar} aria-label='navigation'>
        <div className={styles.navItem}>
          <div className={styles.hamburger} onClick={toggleAside} aria-label='menuToggle' role='button' tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && toggleAside()}>
            <div className={iconStyle}>{showAside ? <CrossIcon /> : <HamburgerIcon />}</div>
          </div>
          <IntLink href={PATH.HOME} passHref>
            <div className={styles.title}>
              <span className={styles.logo}>
                <Logo60 alt='Deagle.dev Logo' />
              </span>
            </div>
          </IntLink>
        </div>
        <div className={styles.navLinks}>
          <ul>
            <li>
              <IntLink href={PATH.ABOUT} passHref>
                <span aria-label={t('about')}>{t('about')}</span>
              </IntLink>
            </li>
            <li>
              <IntLink href={PATH.PROJECT} passHref>
                <span aria-label={t('project')}>{t('project')}</span>
              </IntLink>
            </li>
            <li>
              <IntLink href={PATH.CONTACT} passHref>
                <span aria-label={t('contact')}>{t('contact')}</span>
              </IntLink>
            </li>
          </ul>
        </div>
        <div className={styles.rightSection}>
          <ul>
            <li>
              <ThemeSwitcher />
            </li>
            <li>
              <LocaleSwitcherNav />
            </li>
          </ul>
        </div>
      </nav>
      <AsideNavMenu ref={asideRef} className={styles.aside} isOpen={showAside} onClose={() => setShowAside(false)} />
    </>
  );
};

export default Navbar;
